import React from 'react';

interface RadioOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface RadioGroupProps {
  name: string;
  options: ReadonlyArray<RadioOption>;
  value?: string;
  onChange: (value: string) => void;
  fieldsetClassName?: string;
  legend?: string;
  required?: boolean;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  options,
  value,
  onChange,
  fieldsetClassName = '',
  legend,
  required = false
}) => {
  return (
    <fieldset className={fieldsetClassName}>
      {legend && <legend className="sr-only" id={`${name}-legend`}>{legend}</legend>}
      <div className="radio-group" role="radiogroup" aria-labelledby={legend ? `${name}-legend` : undefined} aria-required={required}>
        {options.map((option) => (
          <label key={option.value} htmlFor={`${name}-${option.value}`}>
            <input
              type="radio"
              id={`${name}-${option.value}`}
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={(e) => onChange(e.target.value)}
              disabled={option.disabled}
              aria-describedby={option.disabled ? `${name}-${option.value}-disabled` : undefined}
            />
            <span>{option.label}</span>
            {option.disabled && (
              <span id={`${name}-${option.value}-disabled`} className="sr-only">
                Denne mulighed er ikke tilgængelig
              </span>
            )}
          </label>
        ))}
      </div>
    </fieldset>
  );
};
